<div class="d-flex ion-align-items-center gap-1">

  <!-- FAVORITE -->
  <div style="color: var(--magenta--600)"
       class="d-flex ion-align-items-center gap-1"
       click-stop-propagation>

    @if (favoriteView() == 'standard') {

      <div [class.ts-caption-bold]="size() == 'small'"
           [class.ts-body-bold]="size() == 'medium'"
           *ngIf="entity()?.metrics?.totFavorite > 0">{{ entity()?.metrics?.totFavorite }}
      </div>

      <ion-icon [ngClass]="size()"
                (click)="onToggle()"
                [name]="entity()?.metrics?.currentUserFavorite ? 'heart': 'heart-outline'"></ion-icon>

    } @else {
      <app-favorite-btn [entity]="entity()"
                        [type]="type()"></app-favorite-btn>
    }


  </div>

</div>
